import { render } from "./FormSection.vue?vue&type=template&id=27edbdc6&scoped=true"
import script from "./FormSection.vue?vue&type=script&lang=js"
export * from "./FormSection.vue?vue&type=script&lang=js"

import "./FormSection.vue?vue&type=style&index=0&id=27edbdc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27edbdc6"]])

export default __exports__